<!-- 流程 -->
<template>
    <div class="flow">
        <div :class="index>=1? 'blue':''">
            <b>1</b>
            <span>打印配置</span>
        </div>
        <i></i>
        <div :class="index>=2? 'blue':''">
            <b>2</b>
            <span>确认下单</span>
        </div>
        <i></i>
        <div :class="index>=3? 'blue':''">
            <b>3</b>
            <span>等待文件</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: String,
            required: '1'
        }
    }
}
</script>

<style lang='less' scoped>
    .flow {
        height: 60px;
        line-height: 60px;
        color: #7c7c7c;
        overflow: hidden;
        b {
            font-weight: 400;
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #d0d0d0;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
        }
        div {
            float: left;
            margin: 0 0%;
            width: 20%;
            text-align: center;
        }
        div:nth-child(1) {
            // margin-left: 1%;
            text-align: left;
            width: 13%;
        }
        div:nth-last-child(1) {
            // margin-right: 1%;
            text-align: right;
            width: 13%;
        }
        i {
            // display: inline-block;
            width: 27%;
            height: 1px;
            background-color: #ccc;
            float: left;
            margin-top: 30px;
        }
        .blue {
            b {
                background-color: #126ead;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/flow.vue